var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GestionLight = function GestionLight(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsxs("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        opacity: ".4",
        d: "M22.952 12C22.952 5.953 18.05 1.05 12 1.05c-.117 0-.233.001-.348.005-1.843.058-2.96 2.058-2.038 3.655a2.437 2.437 0 0 0 2.184 1.225 6.07 6.07 0 0 1 5.357 9.274 2.429 2.429 0 0 0-.037 2.498l.005.009c.916 1.586 3.198 1.639 4.169.086a10.902 10.902 0 0 0 1.66-5.8ZM12 18.071a6.07 6.07 0 0 1-5.155-9.277c.474-.76.485-1.722.037-2.498l-.005-.01C5.96 4.702 3.68 4.649 2.708 6.2a10.9 10.9 0 0 0-1.66 5.8c0 6.05 4.903 10.953 10.952 10.953.116 0 .233-.001.349-.005 1.842-.058 2.959-2.058 2.037-3.655a2.438 2.438 0 0 0-2.184-1.225 6.155 6.155 0 0 1-.202.003Z",
        fill: "#4B22F4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.216 9.954a2.444 2.444 0 1 0 0-4.888 2.444 2.444 0 0 0 0 4.888ZM4.49 18.456a2.444 2.444 0 1 0 0-4.888 2.444 2.444 0 0 0 0 4.888Z",
        fill: "var(--color-primary-light-400)"
      })]
    }))
  });
};
export default GestionLight;